import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { TargetSelector, makeTextStyleSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { localStateSelector } from "../../selectors";
import { type Checkout } from "../../types";
import Component, { type ActionProps, type MapProps } from "./component";
import { makePaymentMethodsSelector } from "./selectors";

type Props = RootContainerProps & {
  billingShipingInfo: Partial<Checkout.BillingInformation>;
};

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const fieldStyleSelector = makeFieldStyleSelector();
  const labelStyleSelector = makeTextStyleSelector(TargetSelector.Entity, "label");
  const paymentMethodsSelector = makePaymentMethodsSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      accounts: localState.userAccounts,
      apiInfo: apiInfoSelector(state, props),
      amount: localState.cart.dueAmount,
      fieldStyle: fieldStyleSelector(state, props),
      currencyCode: localState.currencyCode,
      labelStyle: labelStyleSelector(state, props),
      paymentMethods: paymentMethodsSelector(state, props),
      hasSubscriptionItems: localState.cart.items.some((item) => item.subscriptionInfo != null)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
